<div class="mb-1 text-gray-2 paragraph-2">
  <span class="font-bold text-gray-1">Крок {{ currentStep() }}</span> з 2
</div>

@if (!loading()) {
  @switch (currentStep()) {
    @case (authSteps.PhoneNumber) {
      <form
        class="flex flex-col gap-6"
        [formGroup]="form"
      >
        <h2>Вхід за допомогою коду з СМС</h2>
        <mat-form-field class="w-full">
          <mat-label>Вкажіть номер телефону</mat-label>
          <input
            matInput
            name="phone"
            type="phone"
            formControlName="phone"
          />
          <mat-hint class="text-neutral-300">На вказаний номер буде надіслане повідомлення з кодом підтвердження</mat-hint>
          <mat-error>Невірний номер телефону</mat-error>
        </mat-form-field>

        <div class="mt-11.5 flex justify-end">
          <button
            class="btn btn-primary"
            (click)="selectNextStep()"
          >
            Продовжити
          </button>
        </div>
      </form>
    }
    @default {
      <form
        class="flex w-full flex-col justify-center gap-6"
        [formGroup]="form"
      >
        <h2>Підтвердження номеру телефона</h2>
        <p class="text-center text-neutral-500 paragraph-1">Вкажіть код. Він був відправлений на номер {{ form.controls.phone.value }}</p>
        <div class="flex flex-col items-center justify-center">
          <ng-otp-input
            #otp
            [formCtrl]="password"
            (onInputChange)="requestCodeVerification($event)"
            [config]="{ length: 6 }"
          ></ng-otp-input>
          <span class="text-red-error">
            {{ password.invalid && password.dirty ? ("errors.login.code" | translate) : "\u00a0" }}
          </span>
        </div>
        <div class="flex h-11 justify-between">
          <span
            class="flex cursor-pointer items-center"
            (click)="goBack()"
          >
            <mat-icon>arrow_left</mat-icon>
            Змінити номер телефону
          </span>
          <div class="flex items-center gap-4 text-neutral-300">
            Не отримали код?
            @if (!waitForResend()) {
              <mat-icon
                class="cursor-pointer hover:text-neutral-500"
                aria-hidden="false"
                aria-label="SMS icon"
                [matTooltip]="'context.tooltips.sms' | translate"
                (click)="requestOtpCode()"
              >
                sms
              </mat-icon>
              <mat-icon
                class="cursor-pointer hover:text-neutral-500"
                svgIcon="viber"
                aria-hidden="false"
                aria-label="Viber icon"
                [matTooltip]="'context.tooltips.viber' | translate"
                (click)="requestViberCode()"
              >
              </mat-icon>
            } @else {
              <span class="text-neutral-300">
                <auth-timer (countdownCompleted)="countdownCompleted()"></auth-timer>
              </span>
            }
          </div>
        </div>
      </form>
    }
  }
} @else {
  <div class="h-62.5 flex items-center justify-center">
    <shared-loader></shared-loader>
  </div>
}
